import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import CloseIcon from "@mui/icons-material/Close";
import { Link, Typography } from "@mui/material";
import Avatar from "@mui/joy/Divider";
import SelectDishesCards from "./SelectDishes1Cards";
import ErrorIcon from "@mui/icons-material/Error";
import MealPlan from "../MealPlan/MealPlan";

export default function Select_Dishes() {
  const [state, setState] = React.useState({
    left: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      sx={{
        width:
          anchor === "top" || anchor === "bottom"
            ? "auto"
            : { lg: "708px", md: "708px", sm: "auto", xs: "auto" },
        paddingRight: { lg: "24px", md: "24px", sm: "24px", xs: "0px" },
      }}
      role="presentation"
      // onClick={toggleDrawer(anchor, false)}
      // onKeyDown={toggleDrawer(anchor, false)}
    >
      <Box sx={{ paddingLeft: "24px", paddingBottom: "24px" }}>
        <Box>
          <List>
            <ListItem disablePadding>
              <ListItemButton
                sx={{
                  width: "20px",
                  height: "76px",
                  fontSize: { lg: "24px", md: "24px", sm: "22px", xs: "18px" },
                  fontWeight: "600",
                  fontSize: "24px",
                }}
              >
                <ListItemIcon>
                  <CloseIcon
                    sx={{ color: "#E75C62" }}
                    onClick={toggleDrawer(anchor, false)}
                    onKeyDown={toggleDrawer(anchor, false)}
                  />
                  <ListItemText
                    sx={{
                      paddingRight: {
                        lg: "246px",
                        md: "246px",
                        sm: "246px",
                        xs: "40px",
                      },
                      color: "#000000",
                    }}
                    color="#000000"
                  />{" "}
                  Select Dishes
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </List>
        </Box>

        <Box
          // component={"container"}
          sx={{
            display: {
              xs: "block",
              sm: "block",
              md: "block",
              lg: "block",
            },
            backgroundImage: "url(./images/selectdish1.png)",
            backgroundRepeat: "no-repeat",

            width: { lg: "100%", md: "100%", sm: "686px", xs: "95%" },
            height: {
              xl: "357.47px",
              lg: "357.47px",
              md: "310px",
              // md: "800px",
              sm: "310px",
              xs: "200px",
            },
            backgroundSize: {
              lg: "contain",
              md: "cover",
              sm: "contain",
              xs: "cover",
            },
            borderRadius: "6px",
            // backgroundPosition: "center",
          }}
        >
          <Box sx={{}}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                // paddingRight: "24px",
                // paddingLeft: "16px",
                color: "#FFFFFF",
                paddingTop: {
                  lg: "195px",
                  md: "195px",
                  sm: "210px",
                  xs: "100px",
                },

                height: { lg: "115px", md: "115px", sm: "100px", xs: "100px" },
                borderRadius: "6px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  width: { lg: "100%", md: "100%", sm: "686px", xs: "100%" },
                  justifyContent: "space-between",
                  background:
                    "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%)",
                  borderRadius: "6px",
                }}
              >
                <Box sx={{ paddingLeft: "16px", paddingTop: "6px" }}>
                  <Box>
                    <Typography
                      sx={{
                        fontSize: {
                          lg: "24px",
                          md: "24px",
                          sm: "20px",
                          xs: "18px",
                        },
                        fontWeight: "600",
                      }}
                    >
                      Main Course
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                    <Typography
                      sx={{
                        fontSize: {
                          lg: "18px",
                          md: "18px",
                          sm: "16px",
                          xs: "12px",
                        },
                        fontWeight: "400",
                        paddingTop: "5px",
                      }}
                    >
                      Choose your prefered dishes
                    </Typography>
                    <Box
                      sx={{
                        paddingTop: {
                          lg: "8px",
                          md: "8px",
                          sm: "8px",
                          xs: "4px",
                        },
                        color: "#E75C62",
                        paddingLeft: "14px",
                        height: {
                          lg: "24px",
                          md: "24px",
                          sm: "16px",
                          xs: "12px",
                        },
                      }}
                    >
                      <ErrorIcon
                        sx={{
                          width: {
                            lg: "24px",
                            md: "24px",
                            sm: "16px",
                            xs: "14px",
                          },
                          height: {
                            lg: "24px",
                            md: "24px",
                            sm: "16px",
                            xs: "14px",
                          },
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
                <Box
                  sx={{
                    paddingRight: "24px",
                    paddingTop: {
                      lg: "60px",
                      md: "60px",
                      sm: "50px",
                      xs: "40px",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: {
                        lg: "18px",
                        md: "18px",
                        sm: "16px",
                        xs: "12px",
                      },
                      fontWeight: "600",
                    }}
                  >
                    6/30 Dishes
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
        

        <Box>
          <SelectDishesCards />
        </Box>

        <Box height="96px" sx={{ backgroundColor: "#ffffff" }}>
          <Box sx={{ paddingTop: "20px", paddingRight: {lg: "0px", md: "0px", sm: "20px", xs: "20px" } }}>
            <Button
              variant="contained"
              fullWidth
              size="large"
              sx={{
                textTransform: "capitalize",
                fontSize: { lg: "16px", md: "16px", sm: "10px", xs: "10px" },
                fontWeight: "600",
                height: "48px",
                marginBottom: "24px",
                // position: 'sticky',
              }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );

  return (
    <div>
      {["right"].map((anchor) => (
        <React.Fragment key={anchor}>
          <Button onClick={toggleDrawer(anchor, true)}>{anchor}</Button>
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
      
    </div>
  );
}
